import * as React from 'react';
import { useTheme } from 'styled-components';

interface AvatarIconProps extends React.SVGAttributes<SVGSVGElement> {
	size?: number;
}

const AvatarIcon = ({ size = 40, ...rest }: AvatarIconProps) => {
	const theme = useTheme();

	const circleBackground = theme.primaryBackground;

	return (
		<svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<circle cx="20" cy="20" r="20" fill={circleBackground} />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.8107 14.1892C25.8107 17.3983 23.2092 19.9999 20 19.9999C16.7908 19.9999 14.1893 17.3983 14.1893 14.1892C14.1893 10.98 16.7908 8.37842 20 8.37842C23.2092 8.37842 25.8107 10.98 25.8107 14.1892ZM10.4915 28.4516C10.4915 24.9651 13.3441 22.1126 16.8305 22.1126H23.1695C26.6559 22.1126 29.5085 24.9651 29.5085 28.4516V31.6211H10.4915V28.4516Z"
				fill="white"
			/>
		</svg>
	);
};

export default AvatarIcon;
